module.exports = __webpack_public_path__ + "4f79c5175dcf4d019a48b5b759412fb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/point-noti.png
// module id = 480
// module chunks = 0